module.exports = __webpack_public_path__ + "static/6305-woodrose-14-3942d230fd58ee84bff6c77029422275.jpg";